import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FRAME } from "../core/PageFrame.js";
const { margin, gap } = FRAME.wide;
export function DayGroup({ label, first = false, children }) {
    // The sheet's content box is the frame's content column (its 32px padding offsets its
    // negative margin), so the margin column starts the margin plus the gap to the left.
    const reach = `calc(${margin}px + ${gap})`;
    return (_jsxs("section", { "data-layout": "day-group", "data-day-group": label, "aria-label": label, style: {
            "--day-cols-narrow": "minmax(0, 1fr)",
            "--day-gap-narrow": "0px",
            "--day-reach-narrow": "0px",
            display: "grid",
            gridTemplateColumns: `var(--day-cols, ${margin}px minmax(0, 1fr))`,
            columnGap: `var(--day-gap, ${gap})`,
            marginLeft: `calc(var(--day-reach, ${reach}) * -1)`,
        }, children: [_jsx("h2", { "data-day-label": "", style: {
                    margin: 0,
                    paddingTop: first ? "var(--space-075)" : "var(--space-15)",
                    fontSize: "var(--type-body-size)",
                    lineHeight: "var(--type-body-line)",
                    fontWeight: "var(--type-body-weight-strong)",
                    color: "var(--ink-2)",
                }, children: label }), _jsx("div", { "data-day-rows": "", style: { minWidth: 0, paddingTop: first ? 0 : "var(--space-075)" }, children: children })] }));
}
